import { api } from '@/lib/api'

export function pauseContract({ contractId }: { contractId: string }) {
  return api.post(`/v1/me/contracts/${contractId}/pause`)
}
